function SignUpForm() {
  const options = new Map();

  this.set = (key, value) => {
    options.set(key, value);
  };

  this.get = key => {
    options.get(key);
  };

  this.init = () => {
    let html = document.getElementsByTagName("html");
    this.set("active", false);
    this.set("containerClass", "sign-up-form");
    this.set("html", html[0]);
  };

  this.disable = () => {
    let _outerContainerClasses = document.getElementsByClassName(
      options.get("containerClass")
    );
    for (let i = 0; i < _outerContainerClasses.length; i++) {
      let _outerContainerClass = _outerContainerClasses[i];
      let _bg = _outerContainerClass.parentNode;
      _bg.classList.remove("active");
      options.get("html").classList.remove("fixed");
    }
  };

  this.enable = () => {
    let _outerContainerClasses = document.getElementsByClassName(
      options.get("containerClass")
    );
    for (let i = 0; i < _outerContainerClasses.length; i++) {
      let _outerContainerClass = _outerContainerClasses[i];
      let _bg = _outerContainerClass.parentNode;
      _bg.classList.add("active");
      options.get("html").classList.add("fixed");
    }
  };
}

document.addEventListener("DOMContentLoaded", event => {
  const SIGN_UP_FORM = new SignUpForm();
  SIGN_UP_FORM.init();

  let signUpFormTriggers = document.querySelectorAll("[href='#SignUpForm']");
  for (let i = 0; i < signUpFormTriggers.length; i++) {
    let signUpFormTrigger = signUpFormTriggers[i];

    signUpFormTrigger.addEventListener("click", () => {
      SIGN_UP_FORM.enable();
    });
  }

  let signUpFormClose = document.getElementsByClassName("sign-up-form__close");

  for (let i = 0; i < signUpFormClose.length; i++) {
    signUpFormClose[i].addEventListener("click", () => {
      SIGN_UP_FORM.disable();
    });
  }
});
